import React from 'react';
import Nav from './nav';
import logo from './logo.png';
import './about.css';
import { useState } from 'react';
import founderAdvisorsPartners from './images/founder-advisors-partners.png';

export default function About() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  return (
    <div className="about-root">
      <Nav logo={logo} isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      
      <section className="about-hero">
        <h1>About Kerrigan</h1>
        <p>
          Kerrigan is an AI reasoning platform that learns intuition in expert decision-making environments. We begin with institutional finance, where feedback loops are abundant and measurable, before expanding to other domains requiring high-quality reasoning under uncertainty.

The problem is simple: data fragmentation, decision fragmentation, evaluation fragmentation, and access fragmentation. Kerrigan democratizes institutional-grade investment analysis and cements itself as the goldmine of decision intelligence.
        </p>
      </section>
      <section className="about-people" aria-label="Founder, Advisors, and Partners">
        <img src={founderAdvisorsPartners} alt="Stephen Chang, Advisors, and Partners" />
      </section>

      <section className="about-section">
        <div className="about-grid">
          <div className="about-card">
            <h2>Our Mission</h2>
            <p>
              Our mission is to make expert reasoning measurable, traceable, and usable
              in real time, starting with the institutional investment workflows where
              feedback loops are richest.
            </p>
          </div>

          <div className="about-card">
            <h2>Why We Exist</h2>
            <p>
              Fewer than a dozen firms have world-class research infrastructure. The
              rest of the market is still using the equivalent of rusty shovels to dig
              through the capital markets.
            </p>
          </div>

          <div className="about-card">
            <h2>What We Build</h2>
            <p>
              We build the reasoning layer for investment analysis: connected data,
              explicit decision logic, measurable evaluation loops, and accessible
              institutional-grade workflows.
            </p>
          </div>
        </div>
      </section>

      

      <section className="about-footer">
        <p>
          Kerrigan is built by curious minds exploring the nature of decision-making. We are a team of engineers, researchers, and investors dedicated to building the next generation of intelligence.
        </p>
      </section>
    </div>
  );
}
